import { render } from "./LimitationForm.vue?vue&type=template&id=0277a6de"
import script from "./LimitationForm.vue?vue&type=script&lang=js"
export * from "./LimitationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__